import * as React from 'react'

import {
  Box,
  Button,
  Typography,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip
} from '@mui/material'

import { useDispatch, useSelector } from 'react-redux';

import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import { CTextField } from '../../components/common/TextField';
import {CPageButton, CPageArrowButton, CActionButton} from '../../components/common/Button'

import UserModal from '../../modals/admin/UserModal';  
import { getUsers, deleteUser } from '../../slices/user';

function User() {
  const [openNewUser, setOpenNewUser] = React.useState(false);
  const [mode, setMode] = React.useState("Create");
  const [userData, setUserData] = React.useState({
    email: "",
    firstname: "",
    lastname: "",
    role: "",
    id: ""
  })
  const dispatch = useDispatch();
  const users = useSelector(state => state.user.users);

  React.useEffect(() => {
    let formData = new FormData();
    formData.append("page", 1);
    dispatch(getUsers(formData));
  }, [dispatch])

  const handleOpenNewUser = (e) => {
    setUserData({id: '', email: '', firstname: '', lastname: '', role: ''});
    setMode("Create");
    setOpenNewUser(true);
  }

  const handleCloseNewUser = (e) => {
    setOpenNewUser(false);
    let formData = new FormData();
    formData.append("page", 1);
    dispatch(getUsers(formData))
      .then(res => console.log('okay'))
      .catch(err => console.log(err))
  }

  const handleEdit = (user) => {
    const { id, email, role, first_name: firstname, last_name: lastname } = user;
    setOpenNewUser(true);
    setMode("Update");
    setUserData({id, email, firstname, lastname, role});
  }

  const handleDelete = (id) => {
    if(window.confirm("Do you really want to remove this user?")) {
      dispatch(deleteUser(id))
        .then(res => console.log("DELETE OK"))
        .catch(err => console.log(err))
    }
  }

  return (
    <Box className='w-full flex flex-column flex-basis flex-gap' >
      <Box sx={{paddingTop: 2, paddingLeft: 4}}>
        <Typography 
          sx={{ 
            fontSize: 24, 
            fontWeight: 600, 
            color: '#4A85F6'
          }}
        >
          User Dashboard
        </Typography>
      </Box>
      <Box sx={{paddingTop: 2, gap: 2}} className='flex flex-row align-center'>
        <CTextField
          label=""
          id="search-text-field"
          placeholder='Search'
          sx={{ m: 1, flex: 1, background: 'white'}}
          InputProps={{
            startAdornment: <InputAdornment position="start"><SearchOutlinedIcon /></InputAdornment>,
          }}
        />
        <Button
          sx={{
            textTransform: 'none',
            height: 54,
            borderRadius: 2
          }}
          endIcon={<AddIcon />}
          variant='contained'
          onClick={handleOpenNewUser}
        >
          Add New User
        </Button>
      </Box>
      <Box className='flex-basis'>
        <Paper className='h-full flex flex-column' sx={{borderRadius: 4, margin: 1}}>
          <TableContainer className='flex-basis'>
            <Table sx={{ minWidth: 650, height: '100%' }} size="small" aria-label="a dense table">
              <TableHead sx={{ height: 64}}>
                <TableRow>
                  <TableCell>Email</TableCell>
                  <TableCell>Role</TableCell>
                  <TableCell>Create Date</TableCell>
                  <TableCell sx={{width: 120}}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
              {Array.from({ length: 10 }).map((_, i) => {
                const user = users[i];
                return (
                  <TableRow
                    key={user ? user.id : 1000000+i}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, height: 50 }}
                  >
                    {user ? (
                      <>
                        <TableCell component="th" scope="row">
                          {user.email}
                        </TableCell>
                        <TableCell>
                          <Chip
                            color={
                              user.role === 'SUPER_ADMIN'
                                ? 'primary'
                                : user.role === 'ADMIN'
                                ? 'success'
                                : 'warning'
                            }
                            label={user.role}
                          />
                        </TableCell>
                        <TableCell>{user.created_at}</TableCell>
                        <TableCell>
                          <CActionButton
                            startIcon={<BorderColorIcon />}
                            onClick={() => handleEdit(user)}
                          />
                          <CActionButton
                            startIcon={<DeleteOutlineIcon />}
                            onClick={() => handleDelete(user.id)}
                          />
                        </TableCell>
                      </>
                    ) : (
                      // Render empty cells for blank rows
                      <>
                        <TableCell component="th" scope="row" sx={{borderBottom: 'none'}}></TableCell>
                        <TableCell sx={{borderBottom: 'none'}}></TableCell>
                        <TableCell sx={{borderBottom: 'none'}}></TableCell>
                        <TableCell sx={{borderBottom: 'none'}}></TableCell>
                      </>
                    )}
                  </TableRow>
                );
              })}
              </TableBody>
            </Table>
          </TableContainer>
          <Box
            sx={{
              height: 80,
              paddingLeft: 8,
              paddingRight: 8,
              borderTop: '1px solid rgba(224, 224, 224, 1)'
            }}
            className='flex flex-row align-center justify-between'
          >
            <CPageArrowButton startIcon={<ArrowBackIcon/>} >Previous</CPageArrowButton>
            <Box sx={{color: '#f5f5f5'}}>
              <CPageButton sx={{border: '1px solid #f1f1f1'}}>1</CPageButton>
              <CPageButton>2</CPageButton>
              <CPageButton>3</CPageButton>
              <CPageButton>...</CPageButton>
              <CPageButton>8</CPageButton>
              <CPageButton>9</CPageButton>
              <CPageButton>10</CPageButton>
            </Box>
            <CPageArrowButton endIcon={<ArrowForwardIcon/>} >Next</CPageArrowButton>
          </Box>
        </Paper>
      </Box>
      <UserModal open={openNewUser} data={userData} mode={mode} handleClose={handleCloseNewUser} />
    </Box>
  );
}

export default User;